// @ts-nocheck - Legacy file with extensive type issues requiring comprehensive refactoring (TODO: GXM-XXXX)
import { Card } from "primereact/card";
import { TabView, TabPanel } from "primereact/tabview";
import { InputText } from "primereact/inputtext";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import React, { useEffect, useMemo, useRef, useState } from "react";
import { Toast } from "primereact/toast";
import ToastMessage from "~/components/ToastMessage";
import { getName } from "country-list";
import PermissionGate from "~/components/PermissionGate";
import Notification from "~/components/entities/notification/Notification";
import useShareHolderRegistry from "./useShareHolderRegistry";
import ShareRegistryTable from "../share-registry/ShareRegistryTable";
import AddTransactionModal from "../share-registry/modal/AddTransactionModal";
import ShareholderRegistrationSuccessModal from "../share-registry/modal/ShareholderRegistrationSuccessModal";
import CustomeButton from "~/components/Button";
import OtherEntitiesShareRegistryTable, {
  OtherEntityTransaction,
} from "./OtherEntitiesShareRegistryTable";

import AuditSidebar from "~/components/audit-sidebar/AuditSidebar";
import DeleteConfirmationDialog from "~/components/share-holders/DeleteConfirmationDialog";
import API_ROUTES_V2 from "~/api-routes-v2";
import apiService from "~/services/service";
import { useShareHolderDetails } from "../ShareHolderDetail";

const ShareholderRegistry = () => {
  const { shareholderId: id, entityId } = useParams<{
    shareholderId: string;
    entityId: string;
  }>();
  const navigate = useNavigate();
  const { regData } = useShareHolderDetails();
  const { isAdmin } = useSelector((state: any) => state.login);
  const location = useLocation();
  const { state } = location;
  const [successModalVisible, setSuccessModalVisible] = useState(false);
  const [successShareholder, setSuccessShareholder] = useState<any>(null);

  const {
    shareRegistryData,
    setShareRegistryData,
    modalVisible,
    setModalVisible,
    transaction,
    setTransaction,
    edit,
    setEdit,
    rowIndex,
    setRowIndex,
    loading,
    formatDate,
    fetchShareRegistry,
    updateShareRegistryTransaction,
    addShareRegistryTransaction,
    addShareRegistryTransactionFromState,
    updateShareholderInformation,
    successMessage,
    setSuccessMessage,
    message,
    setMessage,
    isBtnLoading,
    onPageChange,
    pageSize,
    page,
    totalRecords,
    isAuditSidebarVisible,
    setAuditSidebarVisible,
    deleteModalVisible,
    deleteLoading,
    setDeleteModalVisible,
    selectedTransactionToDelete,
    openDeleteTransactionModal,
    deleteShareRegistryTransaction,
  } = useShareHolderRegistry();

  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [isAddingForOtherEntity, setIsAddingForOtherEntity] = useState(false);
  const [otherEntitiesTransactions, setOtherEntitiesTransactions] = useState<
    OtherEntityTransaction[]
  >([]);
  const [otherEntitiesLoading, setOtherEntitiesLoading] = useState(false);
  const [selectedOtherEntityTransaction, setSelectedOtherEntityTransaction] =
    useState<OtherEntityTransaction | null>(null);
  // Pagination state for Other Entities tab
  const [otherEntitiesPage, setOtherEntitiesPage] = useState(0);
  const [otherEntitiesPageSize, setOtherEntitiesPageSize] = useState(10);
  const [otherEntitiesTotalRecords, setOtherEntitiesTotalRecords] = useState(0);

  const currentEntityId = regData?.entityData?.id;
  const currentTenantId = regData?.entityData?.tenant_id;

  const [allEntityOptions, setAllEntityOptions] = useState<
    { id: string; name: string; country: string; label: string }[]
  >([]);
  const [entitiesLoading, setEntitiesLoading] = useState(false);
  const toastRef = useRef<Toast>(null);
  useEffect(() => {
    if (modalVisible && isAddingForOtherEntity && !edit && currentTenantId) {
      const fetchTenantEntities = async () => {
        setEntitiesLoading(true);
        try {
          const response: any = await apiService(
            API_ROUTES_V2.FETCH_ENTITIES_BY_TENANT,
            "GET",
            {
              replace: {
                tenant_id: currentTenantId,
                page: "1",
                pageSize: "500",
                sortBy: "name",
                sortOrder: "asc",
              },
            },
          );
          const entities = response?.data?.entities || response?.data || [];
          const countryName = (code: string) => getName(code) || code;
          const options = entities
            .filter((e: any) => (e.id || e.original_pk) !== currentEntityId)
            .map((e: any) => ({
              id: e.id || e.original_pk,
              name: e.name || "",
              country: e.country || "",
              label: `${e.name || ""} (${(e.country && countryName(e.country)) || e.country || ""})`,
            }));
          setAllEntityOptions(options);
        } catch (err) {
          console.error("Error fetching tenant entities:", err);
          setAllEntityOptions([]);
        } finally {
          setEntitiesLoading(false);
        }
      };
      fetchTenantEntities();
    } else {
      setAllEntityOptions([]);
    }
  }, [
    modalVisible,
    isAddingForOtherEntity,
    edit,
    currentEntityId,
    currentTenantId,
  ]);

  const editTransactionHandler = (data: any, index: any = undefined) => {
    setEdit(true);
    setModalVisible(true);
    setTransaction(data);
    setRowIndex(index);
  };

  // Unified delete handler: Other Entities tab redirects when last registry for that entity removed; This Entity tab navigates when last registry removed (AC2)
  const handleDeleteConfirm = async () => {
    const shareholderName =
      regData?.type === "Individual"
        ? [regData?.name, regData?.last_name]
            .filter(Boolean)
            .join(" ")
            .trim() || "Unknown"
        : regData?.legal_name || "Unknown";
    const entityNameForOther =
      activeTabIndex === 1
        ? selectedTransactionToDelete?.entityData?.name?.trim() || "the entity"
        : null;
    const transactionEntityId =
      selectedTransactionToDelete?.entity_id ||
      selectedTransactionToDelete?.entityData?.id;
    const wasLastForThatEntity =
      activeTabIndex === 1 &&
      !!transactionEntityId &&
      otherEntitiesTransactions.filter(
        (t) => (t.entity_id || t.entityData?.id) === transactionEntityId,
      ).length === 1;

    try {
      const result = await deleteShareRegistryTransaction();
      const { remainingRows, removedFromEntity } = result;

      if (activeTabIndex === 1) {
        await fetchOtherEntitiesTransactions();
        const shouldRedirectAndShowRemovedToast =
          entityId && (removedFromEntity === true || wasLastForThatEntity);
        if (shouldRedirectAndShowRemovedToast) {
          navigate(
            `/entity/${entityId}/appointments-ownership?tab=shareholders`,
            {
              state: {
                shareholderRemovedFromEntity: true,
                shareholderName,
                entityName:
                  entityNameForOther && entityNameForOther.trim()
                    ? entityNameForOther
                    : "the entity",
              },
            },
          );
        } else if (toastRef.current && entityNameForOther) {
          toastRef.current?.show({
            severity: "error",
            summary: "Transaction deleted",
            detail: `Transaction for ${entityNameForOther} has been removed from this profile`,
            icon: "pi pi-check",
            life: 3000,
          });
        }
      } else if (
        activeTabIndex === 0 &&
        entityId &&
        remainingRows.length === 0
      ) {
        navigate(
          `/entity/${entityId}/appointments-ownership?tab=shareholders`,
          {
            state: {
              shareholderRemovedFromEntity: true,
              shareholderName,
              entityIdRemovedFrom: entityId,
            },
          },
        );
      }
    } catch (err) {
      const errorMessage =
        err instanceof Error
          ? err.message
          : "Failed to delete the registry transaction.";
      setMessage(errorMessage);
      setDeleteModalVisible(false);
    }
  };

  const closeModal = () => {
    window.history.replaceState({}, document.title, window.location.pathname);
    setModalVisible(false);
    setEdit(false);
    setTransaction({});
    setRowIndex("");
    setSelectedOtherEntityTransaction(null);
    setIsAddingForOtherEntity(false);
  };

  const openAddModalForThisEntity = () => {
    setIsAddingForOtherEntity(false);
    setTransaction({});
    setModalVisible(true);
  };

  const openAddModalForOtherEntity = () => {
    setIsAddingForOtherEntity(true);
    setTransaction({});
    setModalVisible(true);
  };

  useEffect(() => {
    fetchShareRegistry();
  }, []);

  // Fetch other entities' transactions using /entities/shareholders/{shareholderId}/registry
  // Backend will return all transactions excluding the current entity
  const fetchOtherEntitiesTransactions = async (
    pageNum = otherEntitiesPage,
    pageSizeNum = otherEntitiesPageSize,
  ) => {
    if (!id || !entityId) return;

    try {
      setOtherEntitiesLoading(true);

      const response = await apiService(
        API_ROUTES_V2.OTHER_ENTITIES_REGISTRY,
        "GET",
        {
          skipCache: true,
          replace: {
            shareholderId: id,
            page: String(pageNum + 1),
            pageSize: String(pageSizeNum),
            excludeEntityId: entityId,
          },
        },
      );

      if (response.success) {
        const allTransactions = response.data?.rows || response.data || [];

        setOtherEntitiesTotalRecords(
          response.data?.count || allTransactions.length,
        );
        setOtherEntitiesTransactions(allTransactions);
      }
    } catch (error) {
      console.error("Error fetching other entities transactions:", error);
    } finally {
      setOtherEntitiesLoading(false);
    }
  };

  // Handle page change for Other Entities tab
  const onOtherEntitiesPageChange = (event: { page: number; rows: number }) => {
    setOtherEntitiesPage(event.page);
    setOtherEntitiesPageSize(event.rows);
    fetchOtherEntitiesTransactions(event.page, event.rows);
  };

  const handleTabChange = (index: number) => {
    setActiveTabIndex(index);
    if (index === 1) {
      fetchOtherEntitiesTransactions();
    }
  };

  // Handle editing transaction from Other Entities
  const handleEditOtherEntityTransaction = (
    transaction: OtherEntityTransaction,
  ) => {
    setSelectedOtherEntityTransaction(transaction);
    setEdit(true);
    setModalVisible(true);
    // Include entity_id so the update goes to the correct entity
    setTransaction({ ...transaction, entity_id: transaction.entity_id });
  };

  // Filter This Entity transactions by search term
  const filteredThisEntityTransactions = shareRegistryData.filter((t: any) => {
    if (!searchTerm) return true;
    const searchLower = searchTerm.toLowerCase();
    return (
      t.type?.toLowerCase().includes(searchLower) ||
      t.share_class?.toLowerCase().includes(searchLower) ||
      String(t.share_value)?.toLowerCase().includes(searchLower)
    );
  });

  // Filter Other Entities transactions by search term
  const filteredOtherEntitiesTransactions = otherEntitiesTransactions.filter(
    (t) => {
      if (!searchTerm) return true;
      const searchLower = searchTerm.toLowerCase();
      return (
        t.entityData?.name?.toLowerCase().includes(searchLower) ||
        t.type?.toLowerCase().includes(searchLower) ||
        t.share_class?.toLowerCase().includes(searchLower) ||
        String(t.share_value)?.toLowerCase().includes(searchLower)
      );
    },
  );
  useEffect(() => {
    if (
      state?.shareholder &&
      state?.skipBlocker &&
      shareRegistryData.length >= 0 &&
      !loading
    ) {
      setModalVisible(true);
    }
  }, [state?.shareholder, state?.skipBlocker]);

  const auditLabels = () => {
    return {
      create: "Share Registered",
      update: "Share Updated",
      delete: "Transaction Deleted",
    };
  };

  const renderSearchAndActionBar = (
    onAddClick: () => void,
    placeholder = "Search transaction by type, class or value",
  ) => (
    <div className="flex justify-content-between align-items-center gap-3 mt-3 mb-3">
      <span className="p-input-icon-left p-input-icon-right flex-grow-1">
        <i className="pi pi-search" style={{ left: "0.75rem" }} />
        <InputText
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder={placeholder}
          className="w-full"
          style={{ paddingLeft: "2.5rem", paddingRight: "2.5rem" }}
        />
        <i className="pi pi-search" style={{ right: "0.75rem" }} />
      </span>
      <div className="flex gap-2">
        <PermissionGate
          resource="shareholder"
          action="create"
          resourceAttr={{ entity_id: entityId }}
        >
          <CustomeButton
            label="Add New"
            icon="pi pi-plus"
            iconPos="right"
            variant="contained"
            type="button"
            onClick={onAddClick}
          />
        </PermissionGate>
      </div>
    </div>
  );
  return (
    <Card className="shareholder_registry--card personal-info-card">
      <div className="mb-3 flex justify-content-between formgrid grid grid-nogutter">
        <div>
          <p className="personal-information-heading">Share Registry</p>
        </div>

        {activeTabIndex === 0 && (
          <PermissionGate
            resource="shareholder"
            action="modify"
            resourceAttr={{ entity_id: entityId }}
          >
            <div className="flex gap-2 align-items-center">
              <CustomeButton
                label="View History"
                variant="outlined"
                icon="pi pi-history mb-1 ml-2"
                iconPos="right"
                onClick={() => setAuditSidebarVisible(true)}
              />
            </div>
          </PermissionGate>
        )}
      </div>

      <TabView
        activeIndex={activeTabIndex}
        onTabChange={(e) => handleTabChange(e.index)}
        className="share-registry-tabs"
      >
        <TabPanel header="This Entity">
          <Notification
            successMessage={successMessage}
            setSuccessMessage={setSuccessMessage}
            message={message}
            setMessage={setMessage}
          />
          {renderSearchAndActionBar(
            openAddModalForThisEntity,
            "Search transaction by Transaction type, class or value",
          )}
          <ShareRegistryTable
            shareRegistryData={filteredThisEntityTransactions}
            setModalVisible={setModalVisible}
            formatDate={formatDate}
            editTransactionHandler={editTransactionHandler}
            onDeleteTransaction={(t: any) => openDeleteTransactionModal(t)}
            loading={loading}
            onPageChange={onPageChange}
            pageSize={pageSize}
            page={page}
            totalRecords={totalRecords}
            isEditing={true}
            entityId={entityId}
          />
        </TabPanel>
        <TabPanel header="Other Entities">
          <Notification
            successMessage={successMessage}
            setSuccessMessage={setSuccessMessage}
            message={message}
            setMessage={setMessage}
          />
          {renderSearchAndActionBar(
            openAddModalForOtherEntity,
            "Search transaction by Entity name, Transaction type, class or value",
          )}
          <OtherEntitiesShareRegistryTable
            transactions={filteredOtherEntitiesTransactions}
            loading={otherEntitiesLoading}
            onEditTransaction={handleEditOtherEntityTransaction}
            onDeleteTransaction={(t: any) => openDeleteTransactionModal(t)}
            onPageChange={onOtherEntitiesPageChange}
            page={otherEntitiesPage}
            pageSize={otherEntitiesPageSize}
            totalRecords={otherEntitiesTotalRecords}
            entityId={entityId}
          />
        </TabPanel>
      </TabView>

      <DeleteConfirmationDialog
        visible={deleteModalVisible}
        onConfirm={handleDeleteConfirm}
        onCancel={() => setDeleteModalVisible(false)}
        loading={deleteLoading}
        heading={
          selectedTransactionToDelete?.type
            ? `Are you sure you want to delete this ${selectedTransactionToDelete.type} transaction from the registry?`
            : "Are you sure you want to delete this transaction from the registry?"
        }
        description={
          selectedTransactionToDelete?.type
            ? `Deleting will remove this specific ${selectedTransactionToDelete.type} Share transaction for this Shareholder in the selected entity and all related items from the user interface, including transaction type, value, percentage, date and status.`
            : "Deleting will remove this specific Share transaction for this Shareholder in the selected entity and all related items from the user interface, including transaction type, value, percentage, date and status."
        }
      />

      {/* Transaction Modal */}
      {modalVisible && (
        <AddTransactionModal
          visible={modalVisible}
          setModalVisible={setModalVisible}
          transaction={transaction}
          setTransaction={setTransaction}
          setShareRegistryData={setShareRegistryData}
          edit={edit}
          setEdit={setEdit}
          rowIndex={rowIndex}
          setRowIndex={setRowIndex}
          closeModal={closeModal}
          isEditing={true}
          updateTransaction={async () => {
            // Pass entity_id: use the selected other entity's ID or current entity ID
            const entityIdToUse =
              selectedOtherEntityTransaction?.entity_id || currentEntityId;
            await updateShareRegistryTransaction(entityIdToUse);
            // If editing from Other Entities, refresh that list
            if (selectedOtherEntityTransaction) {
              fetchOtherEntitiesTransactions();
            }
          }}
          addRegistryTransaction={
            state?.shareholder
              ? async () => {
                  const shareholder =
                    await addShareRegistryTransactionFromState(
                      state.shareholder,
                    );
                  setSuccessShareholder(shareholder);
                  setSuccessModalVisible(true);
                }
              : async (entityId?: string | { id?: string }) => {
                  let targetEntityIdValue: string | undefined;
                  const rawTargetId =
                    entityId ??
                    (isAddingForOtherEntity
                      ? transaction?.entity_id
                      : undefined) ??
                    currentEntityId;

                  if (typeof rawTargetId === "string") {
                    targetEntityIdValue = rawTargetId;
                  } else if (
                    rawTargetId &&
                    typeof rawTargetId === "object" &&
                    rawTargetId.id
                  ) {
                    targetEntityIdValue = rawTargetId.id;
                  } else {
                    targetEntityIdValue = currentEntityId;
                  }

                  await addShareRegistryTransaction(targetEntityIdValue);
                  if (
                    isAddingForOtherEntity &&
                    targetEntityIdValue &&
                    targetEntityIdValue !== currentEntityId &&
                    regData?.id
                  ) {
                    await updateShareholderInformation(
                      regData,
                      targetEntityIdValue,
                    );
                  }
                  if (isAddingForOtherEntity) {
                    fetchOtherEntitiesTransactions();
                  }
                }
          }
          isAddingForOtherEntity={isAddingForOtherEntity}
          entityOptions={allEntityOptions}
          entitiesLoading={entitiesLoading}
          currentEntityId={currentEntityId}
          loading={loading}
          isBtnLoading={isBtnLoading}
          addAsShareholder={state?.shareholder ? true : false}
        />
      )}

      {successModalVisible && (
        <ShareholderRegistrationSuccessModal
          visible={successModalVisible}
          closeModal={() => {
            setSuccessModalVisible(false);
            window.history.replaceState(
              {},
              document.title,
              window.location.pathname,
            );
            fetchShareRegistry(true);
          }}
          shareholderName={successShareholder?.full_name}
          shareholderType={successShareholder?.type}
        />
      )}

      {isAuditSidebarVisible && (
        <AuditSidebar
          heading="Share Registry"
          endpoint={API_ROUTES_V2.FETCH_SHAREHOLDER_REGISTRY_AUDIT}
          id={id}
          entityId={entityId}
          objectType="shareholder"
          setSidebarToggle={setAuditSidebarVisible}
          sidebarToggle={isAuditSidebarVisible}
          labels={auditLabels}
        />
      )}
      <ToastMessage ref={toastRef} />
    </Card>
  );
};

export default ShareholderRegistry;
